module.exports = __webpack_public_path__ + "img/transport-scotland.43a243ec.png";